import { Drawer } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { BasePathProvider } from 'components/Providers'
import { hasPermission } from 'store'
import { clearLogs } from 'store/mentorship/log'
import MenteesList from './List/List'
import MenteeLogsDrawer from './Drawer/Logs'

const basePath = '/mentorship/management/mentees'

export default function MenteesPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const list = useSelector(state => state.mentorship.mentorship.list)
  const selected = list?.find(m => String(m.id) === id)
  const isAdmin = hasPermission('mentorship.admin')

  const handleClose = () => {
    dispatch(clearLogs())
    navigate(basePath)
  }

  return (
    <BasePathProvider value={basePath}>
      <MenteesList />
      <Drawer
        PaperProps={{ sx: { width: { xs: '100%', sm: 720 } } }}
        open={Boolean(id)}
        anchor="right"
        onClose={handleClose}
      >
        {selected && (
          <MenteeLogsDrawer mentorship={selected} onClose={handleClose} isAdmin={isAdmin} />
        )}
      </Drawer>
    </BasePathProvider>
  )
}
